import { call, put, takeEvery } from 'redux-saga/effects';
import { USER_RESET_PASSWORD_REQUEST } from '../constants/password.constants';
import { resetPasswordRequestSuccess, resetPasswordRequestFailure } from '../actions/account_actions/reset_password_actions';
import { sendResetPasswordRequest } from '../../requests/account_requests';
import { message_success, message_error } from '../../../../components/Message';
// import { history } from '../../../../config/history';

function* resetPasswordRequest({ token, new_password }) {
    const resetPasswordParams = yield call(sendResetPasswordRequest, token, new_password);
    const { result, error } = resetPasswordParams;
    if (result) {
        yield put(resetPasswordRequestSuccess());
        message_success('Password reset successfully! Please, login with new password!');
    } else {
        yield put(resetPasswordRequestFailure(error));
        message_error(error);
        // history.push('/auth/forgot-password');
    }
}

export default function* resetPasswordSaga() {
    yield takeEvery(USER_RESET_PASSWORD_REQUEST, resetPasswordRequest);
}



// WEBPACK FOOTER //
// ./src/modules/App/redux/sagas/reset_password.saga.js